/* istanbul ignore file */

export const COLORS = {
  primary: '#0072CE',
  gray20: '#333333',
  gray55: '#8C8C8C',
  white: '#FFFFFF',
} as const;
